<div class="tab-content license-agreement">
  <div class="license-layout">
    <div class="license-fields">
      <form [formGroup]="licenseagrmtForm">
        <div class="form-group" *ngIf="!hasLicenseCategory">
          <label>
            <span translate>AGREEMENTSNAME</span>
            <span class="required">*</span>
            <control-messages
              [control]="licenseagrmtForm.controls['AgreementName']"
            ></control-messages>
          </label>
          <input
            type="text"
            formControlName="AgreementName"
            pInputText
            [readonly]="isHide"
            maxlength="100"
          />
        </div>
        <div *ngIf="!isDinHMSLogin" class="form-group">
          <label>
            <span translate>PERSON</span>
          </label>
          <input
            type="text"
            formControlName="SalesPerson"
            pInputText
            [readonly]="isHide"
          />
        </div>
        <div *ngIf="hasLicenseCategory" class="form-group">
          <label>
            <span translate>LICENSE_CATEGORY</span>
            <span class="required">*</span>
          </label>
          <div>
            <p-select
              formControlName="LicenseCategory"
              [options]="licenseCategoryList"
              [style]="{ width: '100%' }"
              [disabled]="isHide"
            ></p-select>
          </div>
          <control-messages
            [control]="licenseagrmtForm.controls['LicenseCategory']"
          ></control-messages>
        </div>
        <div class="form-group-50_50">
          <div
            class="form-group field"
            *ngIf="licenseagrmtForm['controls']?.['PurchaseDate']"
          >
            <label>
              <span translate>PURCHASE_DATE</span>
              <span class="required">*</span>
            </label>
            <div>
              <p-datepicker
                dateFormat="dd/mm/yy"
                [ngStyle]="{
                  width: '100%'
                }"
                [showClear]="true"
                [dateRangeWith]="endCalendar"
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                [showIcon]="true"
                [disabled]="isDatePickerDisabled"
                formControlName="PurchaseDate"
              ></p-datepicker>
            </div>
            <control-messages
              [control]="licenseagrmtForm.controls['PurchaseDate']"
            ></control-messages>
          </div>
          <div class="form-group">
            <label>
              <span translate>EXPIRY_DATE</span>
            </label>
            <div>
              <p-datepicker
                [showClear]="true"
                [showIcon]="true"
                #endCalendar
                dateFormat="dd/mm/yy"
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                [disabled]="isDatePickerDisabled"
                formControlName="ExpiryDate"
              >
              </p-datepicker>
            </div>
          </div>
        </div>
        <div class="form-group-50_50">
          <div class="form-group">
            <label>
              <span translate>LICENSE_MONTH</span>
            </label>
            <div>
              <p-select
                formControlName="LicenseMonth"
                [options]="licenseMonths"
                [style]="{ width: '100%' }"
                [disabled]="isHide"
              ></p-select>
            </div>
          </div>
          <div
            *ngIf="
              licenseagrmtForm.controls['LicenseCategory'].value != 1 &&
              isDinHMSLogin
            "
            class="form-group"
          >
            <label>
              <span translate>PRICE_PER_MONTH</span>
              <span class="required">*</span>
            </label>
            <input
              type="text"
              (keypress)="onPriceChange($event, 10)"
              formControlName="PricePerMonth"
              pInputText
            />
          </div>
        </div>
        <div class="form-group-50_50">
          <div class="form-group">
            <label for="NoOfEmployees">
              <span translate>NUM_EMPLOYEES</span>
            </label>
            <div>
              <input
                type="number"
                pInputText
                id="NoOfEmployees"
                formControlName="NoOfEmployees"
                class="ex-full-width"
                readonly
              />
            </div>
          </div>
          <div class="form-group">
            <label for="NoOfUsers">
              <span translate>NUM_USERS</span>
            </label>
            <div>
              <input
                type="number"
                pInputText
                id="NoOfUsers"
                formControlName="NoOfUsers"
                class="ex-full-width"
                readonly
              />
            </div>
          </div>
        </div>
        <section
          class="employee-license-panel"
          *ngIf="isAdmin"
          aria-labelledby="employee-limit-title"
        >
          <h3 id="employee-limit-title" translate>EMPLOYEE_LIMIT</h3>
          <div class="employee-license-controls">
            <div class="employee-license-number">
              <label for="EmployeeLimit" translate
                >EMPLOYEE_LICENSE.ALLOWED_EMPLOYEES</label
              >
              <input
                type="number"
                pInputText
                id="EmployeeLimit"
                formControlName="EmployeeLimit"
                min="1"
                aria-describedby="employee-limit-help"
                [placeholder]="
                  licenseagrmtForm.value.UnlimitedEmployees
                    ? ('UNLIMITED_EMPLOYEES' | translate)
                    : ''
                "
                [attr.disabled]="
                  licenseagrmtForm.value.UnlimitedEmployees ? '' : null
                "
              />
            </div>
            <label class="employee-license-checkbox" for="UnlimitedEmployees">
              <p-checkbox
                formControlName="UnlimitedEmployees"
                [binary]="true"
                inputId="UnlimitedEmployees"
              ></p-checkbox>
              <span translate>UNLIMITED_EMPLOYEES</span>
            </label>
          </div>
          <employee-license-usage
            [used]="usersCount || 0"
            [limit]="
              licenseagrmtForm.value.UnlimitedEmployees
                ? null
                : licenseagrmtForm.value.EmployeeLimit
            "
          ></employee-license-usage>
          <p id="employee-limit-help" class="employee-license-note" translate>
            EMPLOYEE_LICENSE.LIMIT_HELP
          </p>
        </section>
        <div class="form-group">
          <label>
            <span translate>DESCRIPTION</span>
          </label>
          <textarea
            pTextarea
            formControlName="Description"
            [readonly]="isHide"
          ></textarea>
        </div>
        <div class="form-group">
          <label>
            <span translate>AGREEMENT</span>
          </label>
          <div class="upload-file-container">
            <div class="tab-content">
              <div class="form-group">
                <div class="upload-actions">
                  <label class="btn btn-outline-secondary upload-button">
                    <input
                      type="file"
                      [disabled]="isHide"
                      ngFileSelect
                      accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                      (uploadOutput)="onUploadOutput($event)"
                      [uploadInput]="uploadInput"
                    />{{ "BROWSE" | translate }}
                  </label>
                  <span style="color: green">{{ fileName }}</span>
                </div>
                <div class="upload-items">
                  <div
                    class="upload-item"
                    *ngFor="let f of files; let i = index"
                  >
                    <div class="filename">
                      <span
                        >{{ f.name }} ({{ f.id }}) -
                        {{ f.progress?.data?.percentage }}%</span
                      >
                      <span
                        >uploading with {{ f.progress?.data?.speedHuman }}</span
                      >
                      <span>ETA {{ f.progress?.data?.etaHuman }}</span>
                    </div>
                    <div class="progress">
                      <span
                        class="bar"
                        [style.width]="f?.progress?.data?.percentage + '%'"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a *ngIf="agreement" href="{{ agreement.DocumentPath }}">
          <span *ngIf="agreement.DocumentPath" translate>CLICK_DOWNLOAD</span>
        </a>
      </form>
    </div>
    <section class="license-terms" aria-labelledby="license-terms-title">
      <h4 id="license-terms-title" translate>LICENSE_AGREE</h4>
      <ul>
        <li *ngIf="!isMedi3" translate>UPDATE_CONTINUOUS</li>
        <li *ngIf="isMedi3" translate>MEDI3_UPDATE_CONTINUOUS</li>
        <li translate>SMS_SERVICE</li>
        <li translate>FREE_TELEPHONE_SUPPORT</li>
      </ul>
      <h4 translate>USER_RIGHT</h4>
      <p translate *ngIf="!isMedi3">CONTENT_COPY_ILLEGAL</p>
      <p translate *ngIf="isMedi3">MEDI3_CONTENT_COPY_ILLEGAL</p>
      <h4 translate>GUARANTEE_RESPONSIBILITY</h4>
      <p translate *ngIf="!isMedi3">ERROR_FIXING</p>
      <p translate *ngIf="isMedi3">MEDI3_ERROR_FIXING</p>
      <p translate *ngIf="!isMedi3">BACKUP_SOLUTION</p>
      <p translate *ngIf="isMedi3">MEDI3_BACKUP_SOLUTION</p>
      <h4 translate>LICENSE_PROVISIONS</h4>
      <p translate *ngIf="!isMedi3">VIOLATION_OF_LICENSE</p>
      <p translate *ngIf="isMedi3">MEDI3_VIOLATION_OF_LICENSE</p>
      <p translate>LICENSE_EXPIRY</p>
    </section>
  </div>
  <div
    *ngIf="isAdmin || roleId < 3"
    class="action-btns-wrapper license-actions"
  >
    <div *ngIf="isAdmin" class="license-save-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="clear()">
        <span translate>CLEAR</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSaveBusinessDetails(false)"
        [disabled]="onCheckValidation() || isSubmitting"
      >
        <span translate>SAVE</span>
      </button>
      <button
        *ngIf="isDinHMS"
        type="button"
        class="btn btn-primary"
        (click)="onSaveBusinessDetails(true)"
        [disabled]="onCheckValidation() || isSubmitting"
      >
        <span translate>SAVE_AND_NEXT</span>
      </button>
    </div>
    <button
      *ngIf="roleId < 3"
      type="button"
      class="btn btn-outline-primary license-remote-action"
      (click)="rModeLicenceAgreement()"
      [attr.title]="'LICENSE_REMOTE_MODE_HELP' | translate"
      [attr.aria-label]="
        ('LICENSE_REMOTE_MODE' | translate) +
        '. ' +
        ('LICENSE_REMOTE_MODE_HELP' | translate)
      "
    >
      <i class="pi pi-external-link" aria-hidden="true"></i>
      <span translate>LICENSE_REMOTE_MODE</span>
    </button>
  </div>
</div>

<p-dialog
  [(visible)]="showDowngradeBlocked"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="employee-license-dialog"
  [style]="{ width: '520px', maxWidth: 'calc(100vw - 32px)' }"
  [header]="'EMPLOYEE_LICENSE.DOWNGRADE_TITLE' | translate"
>
  <div class="employee-license-intro">
    <span
      class="employee-license-icon employee-license-icon--warning"
      aria-hidden="true"
      ><i class="pi pi-exclamation-triangle"></i
    ></span>
    <p>
      {{
        "EMPLOYEE_LICENSE.DOWNGRADE_DETAIL"
          | translate: { count: downgradeEmployeesToRemove }
      }}
    </p>
  </div>
  <div class="employee-license-downgrade-stats">
    <div>
      <span translate>EMPLOYEE_LICENSE.ACTIVE_EMPLOYEES</span
      ><strong>{{ usersCount }}</strong>
    </div>
    <div>
      <span translate>EMPLOYEE_LICENSE.REQUESTED_LIMIT</span
      ><strong>{{ licenseagrmtForm.value.EmployeeLimit }}</strong>
    </div>
    <div>
      <span translate>EMPLOYEE_LICENSE.TO_REMOVE</span
      ><strong>{{ downgradeEmployeesToRemove }}</strong>
    </div>
  </div>
  <p class="employee-license-note" translate>
    EMPLOYEE_LICENSE.DOWNGRADE_UNCHANGED
  </p>
  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="goToUserList()"
      translate
    >
      EMPLOYEE_LICENSE.GO_TO_EMPLOYEES
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="showDowngradeBlocked = false"
      translate
    >
      OK
    </button>
  </ng-template>
</p-dialog>
